import { getUsernameForBI } from 'RestAPIs/admin';
import { useQuery } from 'react-query';
import { showErrorSnackbar } from 'components/shared/Snackbar';

const useGetUsernameForBIDB = () => {
  const { data } = useQuery({
    queryKey: ['business-intelligence', 'username'],
    queryFn: async () => {
      const { data } = await getUsernameForBI();
      return data;
    },
    onError: () => {
      showErrorSnackbar();
    }
  });

  return { data };
};

export default useGetUsernameForBIDB;
